import { render, staticRenderFns } from "./TenantEditContactsTab.vue?vue&type=template&id=1e0e2442"
import script from "./TenantEditContactsTab.vue?vue&type=script&lang=ts"
export * from "./TenantEditContactsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports